import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import OrderContainer1 from "../../components/DataContainer/OrderContainer1";
import ErrorPage from "../../shared/ErrorPage";
import Loading from "../../shared/Loading";
import axiosInstance from "../../utilities/axiosInstance/axiosInstance";

const MyOrders = () => {
  const userInfo = JSON.parse(localStorage.getItem("user"));
  const [changes, increaseChanges] = useState(0);
  const {
    isLoading,
    isError,
    data: purchase,
    error,
  } = useQuery(["userorders", changes], async () => {
    let fdata = await axiosInstance.get(`order/find?_id=${userInfo?._id}`);
    console.log(fdata.data);
    return fdata.data;
  });

  const [q, setQ] = useState(0);

  // console.log(purchase);
  if (isError) return <ErrorPage msg={error}></ErrorPage>;
  if (isLoading) return <Loading msg="Loading..."></Loading>;

  return (
    <div className=" py-6 lg:px-10 md:px-10 sm:px-2  w-full ">
      <p className="text-sm font-semibold ">My Orders</p>

      {/* purchase products */}

      {purchase.length === 0 ? (
        <div className="w-full mt-6 p-6 bg-gray-200 rounded text-xs">
          <p>No order Found</p>
        </div>
      ) : (
        purchase?.map((x, index) => {
          return <OrderContainer1 key={index} data={x}></OrderContainer1>;
        })
      )}
      <div className="overflow-auto   rounded mt-4"></div>
    </div>
  );
};

export default MyOrders;
